import * as React from "react";
import './Pick.css';
import '../../components/Typograph.css';
import ImageRadioPicker from "../../components/ImageRadioPicker";
import {BeslagType} from "../../Model";
import oudhollandsImage from '../../images/beslag/oudhollands.jpg'
import traditioneelImage from '../../images/beslag/traditioneel.jpg'
import otherImage from '../../images/template/other1.png'
import PropTypes from "prop-types";
import PhoneAppHeader from "../../components/PhoneAppHeader";
import PhoneAppFooter from "../../components/PhoneAppFooter";
import PickerInfoBox from "../../components/PickerInfoBox";

VersionPick.propTypes = {
    handleNextPage: PropTypes.func.isRequired,
    handlePreviousPage: PropTypes.func.isRequired,
    handlePageChange: PropTypes.func.isRequired,
    allValues: PropTypes.object.isRequired,
    disablePhoneMode: PropTypes.func.isRequired,
}

export default function VersionPick(props) {
    const currentValue = props.allValues.VersionPick;

    return (
        <div className="page">
            <PhoneAppHeader title="Beslag uitvoering" quitPhoneApp={props.disablePhoneMode} onPrevious={props.handlePreviousPage}/>


            <div className="phone-page-middle">
                <h1 className="phone-pick-title">Welk beslagtype heeft u nodig?</h1>

                <div className="phone-pick-body">
                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={BeslagType.OUDHOLLANDS}
                                      image={oudhollandsImage}
                                      small/>

                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={BeslagType.TRADITIONEEL}
                                      image={traditioneelImage}
                                      small/>

                    <ImageRadioPicker onSelect={props.handlePageChange}
                                      current={currentValue}
                                      value={{value: BeslagType.OTHER, text: ""}}
                                      child
                                      image={otherImage}
                                      small/>
                </div>

                <PickerInfoBox
                    options={[
                        {value: BeslagType.OUDHOLLANDS, text: "Oudhollands luikbeslag"},
                        {value: BeslagType.TRADITIONEEL, text: "Traditioneel luikbeslag"},
                        {value: BeslagType.OTHER, text: "Omschrijf hier uw gewenste situatie", withInput: true},
                    ]}
                    current={currentValue}
                    onChangeCurrent={props.handlePageChange}
                />
            </div>
            <PhoneAppFooter onNext={props.handleNextPage}
                            enableNext={!!currentValue}/>
        </div>
    );
}
